import http from "../http-common";

const getAll = () => {
    return http.get("/v1/service/cleaning/room");
};

const get = id => {
    return http.get(`/v1/service/cleaning/room/${id}`);
};

const create = data => {
    return http.post("/v1/service/cleaning/room", data);
};

const update = (id, data) => {
    return http.put(`/v1/service/cleaning/room/${id}`, data);
};

const remove = id => {
    return http.delete(`/v1/service/cleaning/room/${id}`);
};

const removeAll = () => {
    return http.delete(`/v1/service/cleaning/rooms`);
};

const findByName = name => {
    return http.get(`/v1/service/cleaning/room?name=${name}`);
};

export default {
    getAll,
    get,
    create,
    update,
    remove,
    removeAll,
    findByName
};